// Identifiants stables de l'intention, avant toute commande.
// Le texte affiché vit dans Intl.

export const BOOK_INTENT_OCCASIONS = [
	'anniv_couple',
	'anniversaire',
	'noel',
	'saint_valentin',
	'souvenir',
	'plus_tard',
	'autre',
];

export const BOOK_INTENT_DATE_OCCASIONS = ['anniv_couple', 'anniversaire', 'plus_tard'];

// Reprise vers le questionnaire de fin de commande, pour ne pas reposer l'occasion.
export const BOOK_INTENT_TO_ORDER_OCCASION = {
	anniv_couple: 'anniv_couple',
	anniversaire: 'anniversaire',
	noel: 'noel',
	saint_valentin: 'saint_valentin',
	souvenir: 'deuil',
	plus_tard: 'autre_occasion',
	autre: 'autre_occasion',
};

export const BOOK_INTENT_SKIP_LIMIT = 2;

export const BOOK_INTENT_MESSENGERS = [
	'instagram',
	'kakaotalk',
	'line',
	'linkedin',
	'messenger',
	'snapchat',
	'telegram',
	'whatsapp',
	'sms',
];

// Messageries dont le tutoriel change selon l'appareil, et les valeurs
// enregistrées dans preferences.firstMessengerDevice.
export const BOOK_INTENT_DEVICE_MESSENGERS = ['sms', 'whatsapp', 'line', 'kakaotalk'];

export const BOOK_INTENT_DEVICES = ['iphone-mac', 'iphone-pc', 'android', 'iphone'];

function dismissKey(userId) {
	return `mlsmsBookIntentDismissed:${userId || ''}`;
}

export function isBookIntentDismissed(userId) {
	try {
		return sessionStorage.getItem(dismissKey(userId)) === '1';
	} catch (err) {
		return false;
	}
}

export function dismissBookIntentForSession(userId) {
	try {
		sessionStorage.setItem(dismissKey(userId), '1');
	} catch (err) {
		// Session privée : le compteur serveur reste la limite.
	}
}

export function shouldAskBookIntent(user, dismissed = false) {
	if(!user || (user.role && user.role !== 'customer')) {
		return false;
	}
	const intent = (user.preferences && user.preferences.bookIntent) || {};
	if(intent.occasion) {
		return false;
	}
	if((intent.skips || 0) >= BOOK_INTENT_SKIP_LIMIT) {
		return false;
	}
	if(dismissed) {
		return false;
	}
	return true;
}
